import { NormalizedSchema, schema } from "normalizr";

import { UnitSystem } from "@ctra/utils";

import { GamePlanEntity, GamePlanList, TodoItemEntity, TodoItemList } from "./typings";

const todoItem = new schema.Entity("task");

const todoItemList = new schema.Array(todoItem);

/* istanbul ignore next */
const gamePlan = new schema.Entity(
  "gamePlan",
  {
    taskList: todoItemList
  },
  {
    /**
     * @todo adjust to current server spec
     */
    processStrategy: ({
      id,
      title,
      description,
      startEpoch,
      endEpoch,
      goal: { unit, value, unitSystem },
      farmID,
      dataDescriptorID,
      createdBy,
      assignedTo,
      taskList
    }) => ({
      id,
      farmID,
      dataDescriptorID,
      title,
      description,
      createdBy,
      assignedTo,
      taskList,
      timePeriod: {
        startEpoch,
        endEpoch
      },
      goal: {
        unit,
        value: +value
      },
      /**
       * convert to internal structure which is in lower case
       * if no unit system in goal object, assume default as Metric/si
       */
      unitSystem: unitSystem?.toLowerCase() || UnitSystem.metric
    })
  }
);

const gamePlanList = new schema.Array(gamePlan);

export type NormalizedGamePlanList = NormalizedSchema<
  {
    gamePlan: GamePlanList;
    task: Record<TodoItemEntity["id"], TodoItemEntity>;
  },
  Array<GamePlanEntity["id"]>
>;

export type NormalizedGamePlan = NormalizedSchema<
  {
    gamePlan: GamePlanList;
    task: Record<TodoItemEntity["id"], TodoItemEntity>;
  },
  GamePlanEntity["id"]
>;

export type NormalizedTodoItemList = NormalizedSchema<
  {
    task: TodoItemList;
  },
  Array<TodoItemEntity["id"]>
>;

export type NormalizedTodoItem = NormalizedSchema<
  {
    task: TodoItemList;
  },
  TodoItemEntity["id"]
>;

export default {
  gamePlan,
  gamePlanList,
  todoItem,
  todoItemList
};
